export const NOTIFY = {
    name: "notify",
    uuid: 0x6A01,
    properties: ["read", "write", "notify"],
  };
  